//Browser - Detect
//jQuery 1.9 $.browser() API browser() 
/* eslint-disable */

function agent() {
    var o = {};
    var userAgent = navigator.userAgent,
        platformType = navigator.platform.toLowerCase(),
        rWin = /^(win)(32|64)/,
        rMac = /^(mac)/,
        rLinux = /^(linux)/,
        rwebkit = /(webkit)[ \/]([\w.]+)/,
        ropera = /(opera)(?:.*version)?[ \/]([\w.] +) /,
        rmsie = /(msie) ([\w.]+)/,
        rmozilla = /(mozilla)(?:.*? rv:([\w.]+))?/,
        uaMatch = function (ua) {
            ua = ua.toLowerCase();
            var match =
                rwebkit.exec(ua) ||
                ropera.exec(ua) ||
                rmsie.exec(ua) ||
                (ua.indexOf("compatible") < 0 && rmozilla.exec(ua)) ||
                [];
            return {
                browser: match[1] || "",
                version: match[2] || "0",
            };
        },
        platform =
            (rWin.exec(platformType) ||
                rMac.exec(platformType) ||
                rLinux.exec(platformType) ||
                [])[1] || "",
        browserMatch;
    o.browser = {};
    o.platform = {};
    browserMatch = uaMatch(userAgent);

    if (platform !== "") {
        // Tizen OS linux , userAgent Tizen OS.
        if (platform === "linux" && /tizen/i.test(userAgent)) {
            platform = "tizen";
        }
        o.platform[platform] = true;
    }

    if (browserMatch.browser) {
        /**
         * IE11 msie Gecko trident .
         * @since 2014.1.13(#9)
         * @author han1228 <han1228@hancom.com>
         */
        if (browserMatch.browser === "mozilla" && /trident/i.test(userAgent)) {
            browserMatch.browser = "msie";
        }
        o.browser[browserMatch.browser] = true;
        o.browser.version = browserMatch.version;
        o.browser.name = browserMatch.browser;
        var usa = userAgent.toLowerCase(),
            verMatch = null,
            osVerMatch = null,
            edgeVersion = "";
        if (browserMatch.browser === "webkit") {
            // webkit orgWebkit, orgVersion.
            o.browser.orgWebkit = true;
            o.browser.orgVersion = o.browser.version;

            if (/(chrome|crios)\//.test(usa)) {
                if (/(opr)\//.test(usa)) {
                    // .
                    o.browser.opera = true;
                    o.browser.name = "opera";
                    // Opera .
                    verMatch = /(opr)[\/]([\w.]+)/.exec(usa);
                } else if (/(edge)\//.test(usa)) {
                    /** * Windows 10 
                         Microsoft Edge .
                          * webkit , 
                         webkit browser , edge browser .
                          * @since 
                         2015.8.3(#25)
                          * @author 
                         han1228 <han1228@hancom.com>
                          */
                    o.browser.edge = true;
                    o.browser.name = "edge";
                    // Edge .
                    verMatch = /(edge)[\/]([\w.]+)/.exec(usa);
                    if (verMatch) {
                        edgeVersion = verMatch[2];
                    }
                    // Edge  original webkit.(webkit full spec.)
                    if (!edgeVersion || parseFloat(edgeVersion) >= 12) {
                        o.browser.orgWebkit = false;
                    }
                    // Edge IE Type.
                    o.browser.msieType = false;
                    o.browser.msie11Type = false;
                    if (o.browser.orgWebkit === false) {
                        o.browser.msieType = true;
                        o.browser.msie11Type = true;
                    }
                } else if (/(samsungbrowser) \//.test(usa)) {
                    /**
                          * DTV Tizen 
                         OS samsungBrowser .
                          * webkit , webkit browser (orgWebkit ), samsungBrowser browser .
                          * @since 
                         2019.8.9(M10)
                          * @author 
                         han1228 <han1228@hancom.com>
                          */
                    o.browser.samsungBrowser = true;
                    o.browser.name = "samsungBrowser";
                    // Smart TV smartTV.
                    if (/smart-tv/.test(usa)) {
                        o.browser.smartTV = true;
                    }
                    // samsungBrowser.
                    verMatch = /(samsungbrowser)[\/]([\w.]+)/.exec(usa);
                    // Tizen OS OS .
                    osVerMatch = /(tizen)([\w.] +) /.exec(usa);
                } else {
                    // .
                    o.browser.chrome = true;
                    o.browser.name = "chrome";
                    // Chrome .
                    verMatch = /(chrome | crios)[\/]([\w.]+)/.exec(usa);
                }
            } else if (/(safari)\//.test(usa)) {
                // .
                o.browser.safari = true;
                o.browser.name = "safari";
                // Safari .
                verMatch = /(version)[ \/]([\w.] +) /.exec(usa);
                osVerMatch = /(mac os x ) ([\w] +) /.exec(usa); // safari mac os x  }
                // webkit version .
                if (verMatch) {
                    o.browser.version = verMatch[2];
                }
                // os osVersion
                if (osVerMatch) {
                    o.browser.osVersion = osVerMatch[2];
                    if (o.browser.osVersion) {
                        o.browser.osVersion = o.browser.osVersion.split("_").join("."); // dot
                    }
                }
            } else if (browserMatch.browser === "msie") {
                /**
                    * iecompatdata compatibility 
                    userAgent Version 
                    * IE11 .
                    */
                var ieVersion = browserMatch.version
                    ? parseFloat(browserMatch.version)
                    : 0,
                    docMode = document.documentMode;
                if (ieVersion < 11 && docMode) {
                    ieVersion = parseFloat(docMode);
                    if (ieVersion === 11) {
                        o.browser.version = String(ieVersion);
                    }
                }
                // IE .
                o.browser.msieType = true;
                o.browser.msie11Type = !!(
                    o.browser.version && parseInt(o.browser.version, 10) === 11
                );
            }
        }
    }

    return o;
}

let browserInfomation = (function () {
    let instance;
    let uat = navigator.userAgent.toLowerCase();
    function init() {
        return {
            browser: agent().browser,
            browserDevice: {
                isWindows: /(windows)/i.test(uat),
                isMobile: /(mobile|android|ipad|iphone)/i.test(uat),
                isAndroid: /(android)/i.test(uat),
                isIos: /(ipad|iphone|ipot)/i.test(uat),
                isIphone: /(iphone)/i.test(uat),
                isIpad: /(ipad)/i.test(uat),
                isChrome: /(chrome|crios)/i.test(uat),
                IsMac: /macintosh/.test(uat),
                IsLinux: /linux/.test(uat),
                isTizen: /tizen/.test(uat)
            },
        }
    }

    return {
        getInstance: function () {
            if (!instance) {
                instance = init();
            }
            return instance;
        }
    }
})();

export function getInfo() {
    const info = browserInfomation.getInstance();
    const browser = info.browser;
    var Properties = {};

    Properties.BrowserInfo = {
        name: browser.name,
        version: browser.version,
        isEdge: browser.edge,
        isIE: browser.msie,
        isIE11: browser.msie11Type,
        isChrome: browser.chrome,
        isMozilla: browser.mozilla,
        isOrgWebkit: browser.orgWebkit,
        isSafari: browser.safari
    };

    Properties.DeviceInfo = info.browserDevice;
    if ((Properties.BrowserInfo["isIE"] && Properties.BrowserInfo["isIE11"])
        || Properties.BrowserInfo["isChrome"] || Properties.DeviceInfo["isTizen"]) {
        Properties.isViewer = false;
    } else {
        Properties.isViewer = true;
    }
    return Properties;
}